import Link from '@/components/Link';

export default function TrainerListingName({ fullName, uri }) {
  return (
    <Link href={uri} className="text-gray-900 hover:text-green-500">
      <h4 className="font-semibold text-lg lg:text-xl inline-flex items-center space-x-2">
        {fullName}
      </h4>
    </Link>
  );
}
